import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// Import css files
import "slick-carousel/slick/slick.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
